import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"padding":"20px"} }
const _hoisted_4 = {
  key: 0,
  class: "easy-wrap"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"padding":"20px"} }
const _hoisted_7 = { style: {"padding":"20px"} }
const _hoisted_8 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addPassage, allPassage, delPassage,allPassageCategory,allSite,basicConfigPassage,updatePassageState,updateCacheConfigPassage,updatePictureConfigPassage,
  delCacheConfigPassage} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const  httpUrl=getUrl();

const search = reactive({
  key: "",
})

const headers= reactive({
  'token': getToken()
})

const loading = ref(false);
const dataSource = ref([]);

const selectedKeys = ref([]);
const passageCategoryList = ref([]);
const siteList = ref([]);



const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
  { title: "图片", width: "80px", key: "passageImg", align: "center", customSlot: "passageImg" },

  { title: "节点名称", key: "passageName", align: "center", width: "130px" },
  { title: "分类", key: "categoryName", align: "center", width: "130px" },
  { title: "站点名称", key: "siteName", align: "center", width: "130px" },
  { title: "站点网站", key: "website", align: "center", width: "200px" },
  { title: "站点api", key: "websiteApi", align: "center", width: "200px" },
  { title: "资源api", key: "resourceApi", align: "center", width: "200px" },
  { title: "状态", key: "state", align: "center", width: "200px", customSlot: "state" },
  { title: "备注", key: "notes", align: "center" },
  { title: "操作", customSlot: "operator", key: "operator", width: "380px", fixed: "right", align: "center" }
]);


const getAllPassage = () => {
  loading.value = true;
  var data = { "page": page.current, "limit": page.limit, "key": search.key };
  allPassage(JSON.stringify(data)).then((res: any) => {
    loading.value = false;
    if (res != "" && res.code == 0) {
      dataSource.value = res.data;
      page.total = res.count;
    } else {
      dataSource.value = [];
      page.total = 0;
    }
  })
}
//获取数据
getAllPassage();


const getAllPassageCategory=()=>{ 
  var data = { "page":0, "limit": 300 };
  allPassageCategory(JSON.stringify(data)).then((res: any) => { 
    if (res != "" && res.code == 0) {
      passageCategoryList.value = res.data;
     
    }  
  })
}

getAllPassageCategory();

const getAllallSite=()=>{ 
  var data = { "page":0, "limit": 300 };
  allSite(JSON.stringify(data)).then((res: any) => { 
    if (res != "" && res.code == 0) {
      siteList.value = res.data;
     
    }  
  })
}

getAllallSite();





const change = (page: any) => {
  getAllPassage();
}

const sortChange = (key: any, sort: any) => {
  layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
  const changedelFlag = (row: any) => { 
    var data = { "key": row.id, "id": row.state };
    updatePassageState(JSON.stringify(data)).then((res: any) => {
      if (res != "" && res.code == 0) {
        getAllPassage();
        layer.msg("操作成功", { time: 1000, icon: 1 });
      }
    })
  }

//查询接口
const searchUser = () => {
  page.current = 1;
  getAllPassage();
}

//删除
const delNode = (row: any) => {
  var data = { 'id': row.id };
  delPassage(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
      getAllPassage();
      visible11.value = false;
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })


}


const node = reactive({
  passageName: "",
  passageImg: "",
  id: 0,
  sortWeight: 1,
  notes:"",
})


const updateNode = (row: any) => {
  node.passageName = row.passageName;
  node.passageImg = row.passageImg;
  node.sortWeight = row.sortWeight;
  node.notes = row.notes;
  node.id = row.id;
  visible11.value = !visible11.value;
}


//上传文件回调方法
const getUploadFile2 = (res: any) => {
  res = JSON.parse(res.data);
  if (res.code == 0) {
    node.passageImg = res.data.src;

    layer.msg("上传成功", { time: 1000, icon: 1 })
  } else {
    layer.msg("上传异常", { icon: 3, time: 1000 })
  }

}

const layFormRef11 = ref();

const visible11 = ref(false);

const addNode = () => {
  node.id = 0;
  node.passageName = "";
  node.passageImg = "";
  node.sortWeight = 1;
  visible11.value = !visible11.value;
}

const action11 = ref([
  {
    text: "确认",
    callback: () => {
      addPassage(JSON.stringify(node)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPassage();
          visible11.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      visible11.value = false;


    }
  }
])


//底部导航栏选择

const  navigationBarArr=ref([]);

//基本配置
const nodeBasicConfig = reactive({
  resourceApi: "",
  categoryId: 0,
  id: 0,
  siteId: 0,
  showDevice: 1,
  requestMethod: 0,
  templateType: 1,
  isSearch: 0,
  type: 0,
  detailHttp:0,
  shareAddress:"",
  mark:"",
  pinTop:0,
  isfree:0,
  free:0,
  method:1,
  jsUrl:"",
  header:"",
  navigationBar:"",
  videoProxy:0,
  pictureProxy:0,

  
  

})

const basicConfigVisible1 = ref(false);

const basicConfigNode = (row: any) => {
  nodeBasicConfig.resourceApi = row.resourceApi;
  nodeBasicConfig.categoryId = row.categoryId;
  nodeBasicConfig.showDevice = row.showDevice;
  nodeBasicConfig.showDevice = row.showDevice;
  nodeBasicConfig.requestMethod = row.requestMethod;
  nodeBasicConfig.siteId = row.siteId;
  nodeBasicConfig.id = row.id;
  nodeBasicConfig.isSearch = row.isSearch;
  nodeBasicConfig.type = row.type;
  nodeBasicConfig.templateType = row.templateType;
  nodeBasicConfig.detailHttp = row.detailHttp;
  nodeBasicConfig.shareAddress = row.shareAddress;
  nodeBasicConfig.mark=row.mark;
  nodeBasicConfig.pinTop=row.pinTop; 
  nodeBasicConfig.isfree=row.isfree;
  nodeBasicConfig.free=row.free;
  nodeBasicConfig.method=row.method; 
  nodeBasicConfig.jsUrl=row.jsUrl;  
  nodeBasicConfig.navigationBar=row.navigationBar;  
  nodeBasicConfig.header=row.header; 
  nodeBasicConfig.videoProxy=row.videoProxy; 
  nodeBasicConfig.pictureProxy=row.pictureProxy; 

  
  
  if(nodeBasicConfig.mark!=''){
    let passageCategory: never[] = [];
   passageCategoryList.value.forEach(element => {
    if(element.id==16 || element.id==11){
      passageCategory.push(element);
    }
   
    passageCategoryList.value=passageCategory

    
   });


  }


  
  
  basicConfigVisible1.value = !basicConfigVisible1.value;
}


const basicConfigAction1 = ref([
  {
    text: "确认",
    callback: () => { 
      basicConfigPassage(JSON.stringify(nodeBasicConfig)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPassage();
          basicConfigVisible1.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      basicConfigVisible1.value = false;


    }
  }
])




//缓存配置
 
const cacheConfig = reactive({
  cacheTime: "",
  detailCacheTime: "",
  id: 0,

 siteId:0,
 
})

const cacheConfigVisible1 = ref(false);

const cacheConfigNode = (row: any) => {
  cacheConfig.cacheTime = row.cacheTime;
  cacheConfig.detailCacheTime = row.detailCacheTime;
  cacheConfig.siteId = row.siteId; 
  cacheConfig.id = row.id; 
  cacheConfigVisible1.value = !cacheConfigVisible1.value;
}


const cacheConfigAction1 = ref([
  {
    text: "确认",
    callback: () => {
      updateCacheConfigPassage(JSON.stringify(cacheConfig)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPassage();
          cacheConfigVisible1.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      cacheConfigVisible1.value = false;


    }
  }
])


//删除缓存
const  delCacheConfig=()=>{  
   var data={"id":cacheConfig.id}
  
  delCacheConfigPassage(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) { 
         
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })


}


//图片配置
const pictureConfig = reactive({
  decryptionType: 0,
  decryptKey: "",
  decryptIv:'',
  serverUrl:'',
  serverDecryption :0,
  id: 0,
  jsUrl:"",
 
})

const pictureConfigVisible1 = ref(false);

const pictureConfigNode = (row: any) => {
  pictureConfig.decryptionType = row.decryptionType;
  pictureConfig.decryptKey = row.decryptKey;
  pictureConfig.decryptIv = row.decryptIv;
  pictureConfig.serverUrl = row.serverUrl;
  pictureConfig.serverDecryption = row.serverDecryption; 
  pictureConfig.jsUrl = row.jsUrl; 
 
  
  pictureConfig.id = row.id; 
  pictureConfigVisible1.value = !pictureConfigVisible1.value;
}


const pictureConfigAction1 = ref([
  {
    text: "确认",
    callback: () => {
      updatePictureConfigPassage(JSON.stringify(pictureConfig)).then((res: any) => {
        if (res != "" && res.code == 0) {
          getAllPassage();
          pictureConfigVisible1.value = false;
          layer.msg("操作成功", { time: 1000, icon: 1 });
        }
      })
    }
  },
  {
    text: "取消",
    callback: () => {
      pictureConfigVisible1.value = false;


    }
  }
])



 



return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_upload = _resolveComponent("lay-upload")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_radio = _resolveComponent("lay-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "节点",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入节点名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: addNode,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "开启",
                      "unswitch-text": "关闭"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  passageImg: _withCtx(({ row }) => [
                    _createElementVNode("img", {
                      src: row.passageImg,
                      style: {"width":"60px","height":"60px"}
                    }, null, 8, _hoisted_2)
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateNode(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (basicConfigNode(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("基本配置")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (row.mark=='')
                      ? (_openBlock(), _createBlock(_component_lay_button, {
                          key: 0,
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (cacheConfigNode(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("缓存配置")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (row.mark=='')
                      ? (_openBlock(), _createBlock(_component_lay_button, {
                          key: 1,
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (pictureConfigNode(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("图片配置")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (delNode(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['450px', '540px'],
      btn: action11.value,
      title: "添加/修改节点"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lay_form, {
            model: node,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "图片",
                prop: "passageImg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_upload, {
                    onDone: getUploadFile2,
                    disabledPreview: false,
                    multiple: false,
                    acceptMime: "image/*",
                    url: _unref(httpUrl)+'/common/imgUpload/node',
                    field: "file",
                    headers: headers
                  }, {
                    preview: _withCtx(() => [
                      (node.passageImg != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("img", {
                              src: node.passageImg,
                              style: {"width":"60px","height":"60px"}
                            }, null, 8, _hoisted_5)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["url", "headers"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "名称节点",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: node.passageName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((node.passageName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "排序",
                prop: "sortWeight"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: node.sortWeight,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((node.sortWeight) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "notes"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: node.notes,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((node.notes) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: basicConfigVisible1.value,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((basicConfigVisible1).value = $event)),
      shade: false,
      area: ['450px', '680px'],
      btn: basicConfigAction1.value,
      title: "节点基本配置"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_lay_form, { model: nodeBasicConfig }, {
            default: _withCtx(() => [
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "资源api",
                    prop: "userName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: nodeBasicConfig.resourceApi,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((nodeBasicConfig.resourceApi) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "节点分类",
                prop: "sortWeight"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: nodeBasicConfig.categoryId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((nodeBasicConfig.categoryId) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(passageCategoryList.value, (value, key) => {
                        return (_openBlock(), _createBlock(_component_lay_select_option, {
                          key: key,
                          value: value.id,
                          label: value.categoryName
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "显示首页",
                prop: "pinTop"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.pinTop,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((nodeBasicConfig.pinTop) = $event)),
                    name: "pinTop",
                    value: 0,
                    label: "不显示"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.pinTop,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((nodeBasicConfig.pinTop) = $event)),
                    name: "pinTop",
                    value: 1,
                    label: "显示"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 1,
                    label: "站点选择",
                    prop: "sortWeight"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: nodeBasicConfig.siteId,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((nodeBasicConfig.siteId) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siteList.value, (value, key) => {
                            return (_openBlock(), _createBlock(_component_lay_select_option, {
                              key: key,
                              value: value.id,
                              label: value.siteName
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "显示设备",
                prop: "showDevice"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.showDevice,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((nodeBasicConfig.showDevice) = $event)),
                    name: "showDevice",
                    value: 0,
                    label: "全部"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.showDevice,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((nodeBasicConfig.showDevice) = $event)),
                    name: "showDevice",
                    value: 1,
                    label: "h5"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.showDevice,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((nodeBasicConfig.showDevice) = $event)),
                    name: "showDevice",
                    value: 2,
                    label: "app"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: nodeBasicConfig.showDevice,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((nodeBasicConfig.showDevice) = $event)),
                    name: "showDevice",
                    value: 3,
                    label: "pc"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 2,
                    label: "请求方式",
                    prop: "requestMethod"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: nodeBasicConfig.requestMethod,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((nodeBasicConfig.requestMethod) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 0,
                            label: "接口请求"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "本地请求"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "js处理"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='' && nodeBasicConfig.requestMethod==2)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 3,
                    label: "请求类型",
                    prop: "requestMethod"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: nodeBasicConfig.method,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((nodeBasicConfig.method) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "POST"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "GET"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark==''&& nodeBasicConfig.requestMethod==2)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 4,
                    label: "js地址",
                    prop: "jsUrl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: nodeBasicConfig.jsUrl,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((nodeBasicConfig.jsUrl) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 5,
                    label: "模板选择",
                    prop: "templateType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select, {
                        modelValue: nodeBasicConfig.templateType,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((nodeBasicConfig.templateType) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_lay_select_option, {
                            value: 1,
                            label: "模板1"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 2,
                            label: "模板2"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 3,
                            label: "模板3"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 4,
                            label: "模板4"
                          }),
                          _createVNode(_component_lay_select_option, {
                            value: 5,
                            label: "模板5"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 6,
                    label: "是否免费",
                    prop: "isfree"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.isfree,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((nodeBasicConfig.isfree) = $event)),
                        name: "isfree",
                        value: 0,
                        label: "收费"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.isfree,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((nodeBasicConfig.isfree) = $event)),
                        name: "isfree",
                        value: 1,
                        label: "免费"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.isfree==0 && nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 7,
                    label: "免费时长",
                    prop: "free"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: nodeBasicConfig.free,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((nodeBasicConfig.free) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 8,
                    label: "图片代理",
                    prop: "pictureProxy"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.pictureProxy,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((nodeBasicConfig.pictureProxy) = $event)),
                        name: "pictureProxy",
                        value: 0,
                        label: "关闭"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.pictureProxy,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((nodeBasicConfig.pictureProxy) = $event)),
                        name: "pictureProxy",
                        value: 1,
                        label: "开启"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 9,
                    label: "视频代理",
                    prop: "videoProxy"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.videoProxy,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((nodeBasicConfig.videoProxy) = $event)),
                        name: "videoProxy",
                        value: 0,
                        label: "关闭"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.videoProxy,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((nodeBasicConfig.videoProxy) = $event)),
                        name: "videoProxy",
                        value: 1,
                        label: "开启"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 10,
                    label: "搜索栏开关",
                    prop: "isSearch"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.isSearch,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((nodeBasicConfig.isSearch) = $event)),
                        name: "isSearch",
                        value: 0,
                        label: "开启"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.isSearch,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((nodeBasicConfig.isSearch) = $event)),
                        name: "isSearch",
                        value: 1,
                        label: "关闭"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_lay_form_item, {
                label: "类型选择",
                prop: "sortWeight"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: nodeBasicConfig.type,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((nodeBasicConfig.type) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (nodeBasicConfig.mark=='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 0,
                            value: 1,
                            label: "通用"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark=='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 1,
                            value: 2,
                            label: "风楼"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark=='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 2,
                            value: 3,
                            label: "图文"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark!='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 3,
                            value: 4,
                            label: "跳转外部"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark!='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 4,
                            value: 5,
                            label: "分享地址"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark!='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 5,
                            value: 12,
                            label: "交流群"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark!='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 6,
                            value: 13,
                            label: "关于"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark=='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 7,
                            value: 14,
                            label: "AI脱衣"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark=='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 8,
                            value: 15,
                            label: "短视频综合"
                          }))
                        : _createCommentVNode("", true),
                      (nodeBasicConfig.mark!='')
                        ? (_openBlock(), _createBlock(_component_lay_select_option, {
                            key: 9,
                            value: 16,
                            label: "更新日志"
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (nodeBasicConfig.type==2)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 11,
                    label: "请求页面请求",
                    prop: "detailHttp"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.detailHttp,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((nodeBasicConfig.detailHttp) = $event)),
                        name: "isSearch",
                        value: 0,
                        label: "开启"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_lay_radio, {
                        modelValue: nodeBasicConfig.detailHttp,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((nodeBasicConfig.detailHttp) = $event)),
                        name: "isSearch",
                        value: 1,
                        label: "关闭"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 12,
                    prop: "header"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_textarea, {
                        placeholder: "请输入图片请求头JSON类型",
                        modelValue: nodeBasicConfig.header,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((nodeBasicConfig.header) = $event)),
                        style: {"height":"100px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.type!=13 && nodeBasicConfig.type!=3 && nodeBasicConfig.type!=12 && nodeBasicConfig.type!=5 && nodeBasicConfig.mark=='')
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 13,
                    prop: "navigationBar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_textarea, {
                        placeholder: "请输入底部导航栏JSON数组(底部导航栏只能放三个按钮)",
                        modelValue: nodeBasicConfig.navigationBar,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((nodeBasicConfig.navigationBar) = $event)),
                        style: {"height":"300px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.type==4 || nodeBasicConfig.type==5 ||nodeBasicConfig.type==12)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 14,
                    label: "地址",
                    prop: "shareAddress"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: nodeBasicConfig.shareAddress,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((nodeBasicConfig.shareAddress) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (nodeBasicConfig.type==13)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 15,
                    label: "",
                    prop: "shareAddress"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_textarea, {
                        placeholder: "请输入描述",
                        modelValue: nodeBasicConfig.shareAddress,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((nodeBasicConfig.shareAddress) = $event)),
                        style: {"height":"300px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: cacheConfigVisible1.value,
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((cacheConfigVisible1).value = $event)),
      shade: false,
      area: ['400px', '350px'],
      btn: cacheConfigAction1.value,
      title: "缓存设置"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_lay_form, {
            model: cacheConfig,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                prop: "passageImg",
                style: {"text-align":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_button, {
                    type: "danger",
                    onClick: delCacheConfig
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("删除缓存")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "列表缓存时间",
                prop: "cacheTime"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: cacheConfig.cacheTime,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((cacheConfig.cacheTime) = $event)),
                    placeholder: "请输入缓存时间（分钟）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "详情缓存时间",
                prop: "detailCacheTime"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: cacheConfig.detailCacheTime,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((cacheConfig.detailCacheTime) = $event)),
                    placeholder: "请输入缓存时间（分钟）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: pictureConfigVisible1.value,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((pictureConfigVisible1).value = $event)),
      shade: false,
      area: ['400px', '450px'],
      btn: pictureConfigAction1.value,
      title: "图片解密设置"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_lay_form, {
            model: pictureConfig,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "解密方法",
                prop: "passageImg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: pictureConfig.decryptionType,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((pictureConfig.decryptionType) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 0,
                        label: "无"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "方法1"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "方法2"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 3,
                        label: "方法3"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 4,
                        label: "方法4"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 5,
                        label: "方法5"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 6,
                        label: "方法6"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 7,
                        label: "方法7"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 8,
                        label: "方法8"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 10,
                        label: "方法10"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 11,
                        label: "方法11"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 12,
                        label: "方法12"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 13,
                        label: "方法13"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 14,
                        label: "方法14"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 15,
                        label: "方法15"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 9,
                        label: "js解密"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "解密Key",
                prop: "decryptKey"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: pictureConfig.decryptKey,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((pictureConfig.decryptKey) = $event)),
                    placeholder: "请输入解密Key"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "解密IV",
                prop: "decryptIv"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: pictureConfig.decryptIv,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((pictureConfig.decryptIv) = $event)),
                    placeholder: "请输入解密IV"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "服务器解密",
                prop: "serverDecryption"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: pictureConfig.serverDecryption,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((pictureConfig.serverDecryption) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: 0,
                        label: "出租需要解密"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 1,
                        label: "不解密"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: 2,
                        label: "全部解密"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              ( pictureConfig.decryptionType==9)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "js地址",
                    prop: "jsUrl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: pictureConfig.jsUrl,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((pictureConfig.jsUrl) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (pictureConfig.serverDecryption==0||pictureConfig.serverDecryption==2)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 1,
                    label: "图片网址",
                    prop: "serverUrl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: pictureConfig.serverUrl,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((pictureConfig.serverUrl) = $event)),
                        placeholder: "请输入图片服务器网址"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})